import React, { useEffect } from 'react';
import { Dialog } from '@material-ui/core';

/**
 * Wrench icon for maintenance mode.
 */
function WrenchIcon({ size = 50 }: { size?: number }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="#5d78ff"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      style={{ flexShrink: 0 }}
    >
      <path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z" />
    </svg>
  );
}

interface Props {
  expectedEndTime?: string | null;
}

/**
 * Blocking maintenance dialog shown when the system is in maintenance mode.
 */
export function MaintenanceModeDialog({ expectedEndTime = null }: Props) {
  // Hide the splash screen element (it's outside React's render tree)
  useEffect(() => {
    const splashScreen = document.getElementById('splash-screen');
    if (splashScreen) {
      splashScreen.classList.add('hidden');
    }
  }, []);

  return (
    <Dialog
      open
      disableBackdropClick
      disableEscapeKeyDown
      maxWidth={false}
      aria-labelledby="maintenance-dialog-title"
      aria-describedby="maintenance-dialog-description"
      PaperProps={{
        style: {
          maxWidth: 490,
          width: '100%',
          margin: 16,
          borderRadius: 12,
          boxShadow: '0px 2px 4px 0px rgba(0,0,0,0.2), 0px 0px 20px 0px rgba(0,0,0,0.15)',
          overflow: 'hidden',
        },
      }}
      BackdropProps={{
        style: {
          backgroundColor: '#f2f3f8',
        },
      }}
    >
      <div style={{ padding: 24, display: 'flex', flexDirection: 'column', gap: 16 }}>
        <WrenchIcon />
        <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
          <h2
            id="maintenance-dialog-title"
            style={{
              margin: 0,
              fontFamily: "'Manrope', sans-serif",
              fontWeight: 800,
              fontSize: 20,
              lineHeight: '24px',
              color: '#333',
            }}
          >
            We're under maintenance
          </h2>
          <p
            id="maintenance-dialog-description"
            style={{
              margin: 0,
              fontFamily: "'Manrope', sans-serif",
              fontWeight: 400,
              fontSize: 14,
              lineHeight: '24px',
              color: '#333',
            }}
          >
            We're currently performing scheduled maintenance to improve Datarova.
          </p>
          {expectedEndTime && (
            <p
              style={{
                margin: 0,
                fontFamily: "'Manrope', sans-serif",
                fontWeight: 400,
                fontSize: 14,
                lineHeight: '20px',
                color: '#666',
              }}
            >
              Expected completion: {expectedEndTime}
            </p>
          )}
        </div>
      </div>
    </Dialog>
  );
}

